<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de Churns'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters complete-filter">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="info-card-blue">
                    <div>1</div>
                    <div>Data início e fim</div>
                    <div>Preencha os filtros para buscar um Excel mais detalhado.</div>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen3" v-model="dates.initialDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen4" v-model="dates.finalDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3 offset-top-20">
                  <button v-on:click="getChurnComplete()">Download Excel Detalhado</button>
                </div>
              </div>
            </div>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Mês</label>
                      <select v-model="dataSearch.month">
                        <option value="">Selecione</option>
                        <option value="1">Janeiro</option>
                        <option value="2">Fevereiro</option>
                        <option value="3">Março</option>
                        <option value="4">Abril</option>
                        <option value="5">Maio</option>
                        <option value="6">Junho</option>
                        <option value="7">Julho</option>
                        <option value="8">Agosto</option>
                        <option value="9">Setembro</option>
                        <option value="10">Outubro</option>
                        <option value="11">Novembro</option>
                        <option value="12">Dezembro</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Ano</label>
                      <select v-model="dataSearch.year">
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                        <option value="2020">2020</option>
                        <option value="2021">2021</option>
                        <option value="2022">2022</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="planStr">Plano</label>
                      <input v-model="dataSearch.planStr" type="text" class="form-control" id="planStr" name="planStr">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="companyCreatedAt">Data Inicio</label>
                      <input v-model="dataSearch.companyCreatedAt" type="text" class="form-control"
                             id="companyCreatedAt" name="companyCreatedAt">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="userName">Feito por</label>
                      <input v-model="dataSearch.userName" type="text" class="form-control" id="userName"
                             name="userName">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Tipo de motivo</label>
                      <select v-model="dataSearch.typeMotive">
                        <option value="">Selecione um tipo de motivo</option>
                        <option v-for="(value, index) in typeMotives" :value="value.id" :key="index">{{
                            value.name
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataChurn !== '' && !dataChurn.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum resultado encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição, tente novamente ou contate os DEVS.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataChurn.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Quantidade total ({{ dataChurn.length }})
                    </span>
                  </div>

                  <a v-on:click="downloadActualListExcel()" class="btn-all-excel right" title="Imprimir">
                    <span>Gerar Excel</span>
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                  </a>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <p class="price-value">Valor total: <span>R$ {{ totalValue }}</span></p>
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> TIPO DE MOTIVO</th>
                        <th> MOTIVO</th>
                        <th> VALOR</th>
                        <th> VENDEDOR</th>
                        <th> QUEM REALIZOU O CHURN</th>
                        <th> DATA DO CADASTRO</th>
                        <th> INICIO DO CONTRATO</th>
                        <th> DATA (CHURN)</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in dataChurn">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.context" target="_blank"
                               class="link">{{ c.companyName }}</a></td>
                        <td>{{ c.churnCategoryName }}</td>
                        <td>{{ c.motive }}</td>
                        <td>R$ {{ c.value }}</td>
                        <td>{{ c.closerName }}</td>
                        <td>{{ c.userName }}</td>
                        <td>{{ c.companyCreatedAt | formatDate }}</td>
                        <td>{{ c.initContract }}</td>
                        <td>{{ c.createdAt | formatDate }}</td>
                        <td>
                          <a v-on:click="removeChurn(c, index)" title="Remover" class="btn-to-delete">
                            <i class="fa fa-ban" aria-hidden="true"></i> Remover
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  COMPANY_CHURN_REQUEST,
  REMOVE_FROM_CHURN,
  GET_CHURN_REPORT_COMPLETE, GET_CHURN_CATEGORY
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import swal from "sweetalert";

export default {
  name: "list-churns-old",
  components: {
    topMenu,
    datepicker,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      data: "",
      loadingCsv: false,
      ptBR: ptBR,
      dates: {
        initialDate: "",
        finalDate: ""
      },
      totalValue: 0,
      failRequest: false,
      loadingChurn: false,
      loadingList: false,
      typeMotives: '',
      dataChurn: [],
      dataSearch: {
        typeMotive: "",
        month: "",
        year: "2024",
        planStr: "",
        companyCreatedAt: "",
        userName: ""
      }
    };
  },
  methods: {
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getChurnComplete() {
      if (this.dates.initialDate && this.dates.finalDate) {
        if (!this.loadingCsv) {
          this.loadingCsv = true;
          let url = GET_CHURN_REPORT_COMPLETE;
          url += "?init=" + moment(this.dates.initialDate).format("YYYY-MM-DD");
          url += "&end=" + moment(this.dates.finalDate).format("YYYY-MM-DD");
          UTIL_SERVICE.console("URL SEARCH:", url);
          REQUEST_SERVICE.getFile(url, true)
            .then(data => {
              UTIL_SERVICE.console("RESULT SEARCH USER:", data);

              let headers = data.headers;

              let filename = headers["x-filename"];
              let contentType = headers["content-type"];

              let linkElement = document.createElement("a");
              try {
                let blob = new Blob([data.data], {
                  type: contentType
                });
                let url = window.URL.createObjectURL(blob);

                linkElement.setAttribute("href", url);
                linkElement.setAttribute("download", "relatorio-de-churn.csv");

                let clickEvent = new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: false
                });
                linkElement.dispatchEvent(clickEvent);
                this.loadingCsv = false;
              } catch (e) {
                this.loadingCsv = false;
              }
            })
            .catch(reason => {
              this.loadingCsv = false;
              reason.response.data.erros.map((value, index) => {
                swal("Aviso", value.value, "error");
              });
            });
        }
      } else {
        swal("Aviso", "Por favor preencha as datas para continuar.", "error");
      }
    },
    removeChurn(data, index) {
      if (!this.loadingChurn) {
        this.loadingChurn = true;
        this.failRequest = false;
        let url = REMOVE_FROM_CHURN;

        url += "?id=" + data.id;
        url += "&connection=" + data.context;

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.get(url)
          .then(response => {
            UTIL_SERVICE.console(
              "RESULT COMPANY_CHURN_REQUEST:",
              response.data
            );

            ALERT_SERVICE.swal("Aviso", response.data, "success");
            this.dataChurn.splice(index, 1);
            this.loadingChurn = false;
          })
          .catch(reason => {
            this.loadingChurn = false;

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
      }
    },
    downloadActualListExcel() {
      let bodyValue = [];
      this.dataChurn.map((value, index) => {
        bodyValue.push([
          value.companyName,
          value.churnCategoryName,
          value.motive,
          value.value,
          value.closerName,
          moment(String(value.companyCreatedAt)).format("DD/MM/YYYY"),
          value.initContract,
          moment(String(value.createdAt)).format("DD/MM/YYYY")
        ]);

        if (index + 1 === this.dataChurn.length) {
          let headValue = ["EMPRESA", "TIPO DE MOTIVO", "MOTIVO", "VALOR", "VENDEDOR", "DATA DO CADASTRO", "INICIO DO CONTRATO", "DATA"];
          window.downloadListExcel(headValue, bodyValue, "Relatório de Churn");
        }
      });
    },
    getTypeMotive() {
      REQUEST_SERVICE.get(GET_CHURN_CATEGORY)
        .then(response => {
          UTIL_SERVICE.console("RESULT GET_CHURN_CATEGORY:", response.data);

          this.typeMotives = response.data
        })
        .catch(reason => {
          console.log('Erro ao carregar os motivos', reason)
        });
    },
    getList() {
      this.dataChurn = [];
      this.loadingList = true;
      this.failRequest = false;
      let url = COMPANY_CHURN_REQUEST;
      url += "?year=" + this.dataSearch.year;

      if (this.dataSearch.month) url += "&month=" + this.dataSearch.month;

      if (this.dataSearch.planStr) url += "&planStr=" + this.dataSearch.planStr;

      if (this.dataSearch.companyCreatedAt)
        url += "&companyCreatedAt=" + this.dataSearch.companyCreatedAt;

      if (this.dataSearch.userName)
        url += "&userName=" + this.dataSearch.userName;

      if (this.dataSearch.typeMotive !== '')
        url += "&churnCategoryId=" + this.dataSearch.typeMotive;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url)
        .then(response => {
          UTIL_SERVICE.console("RESULT COMPANY_CHURN_REQUEST:", response.data);

          this.dataChurn = response.data;
          this.totalValue = 0;
          this.dataChurn.map((value, index) => {
            this.totalValue += value.value;
          });
          this.loadingList = false;
        })
        .catch(reason => {
          this.loadingList = false;
          this.failRequest = true;

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
    }
  },
  beforeMount() {
    const data = new Date();
    this.dataSearch.month = data.getMonth() + 1;

    this.getTypeMotive();
    this.getList();
  }
};
</script>

<style lang="scss">
.complete-filter {
  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

  button {
    width: auto;
    margin-top: 20px;
    padding: 0 20px;
  }
}

.price-value {
  display: block;
  margin-bottom: 20px;
  font-weight: 600;
  text-transform: capitalize;
  color: #444D58;
  font-size: 16px;
  margin-left: 6px;
  margin-top: 0;

  span {
    color: #E7505A;
  }
}

.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00A651;
  color: #FFF;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #FFF;
    background-color: #008D45;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/listChurnsOld.vue